import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export default function ErrorPage() {
	const error: any = useRouteError();
	console.error(error);

	const errorText = isRouteErrorResponse(error)
		? `${error.status} ${error.statusText}`
		: error.message || "Unknown Error";

	return (
		<div id="error-page">
			<h1>Oops!</h1>
			<p>Sorry, an unexpected error has occurred.</p>
			<p>
				<i>{errorText}</i>
			</p>
		</div>
	);
}
